<div class="bg-white px-3 sm:px-4 md:px-8 lg:px-16 pt-6 pb-3">
    <!-- Breadcrumb -->
    <div class="flex items-center gap-2 text-body text-base mb-6">
        <a routerLink="/" class="hover:text-primary">{{ 'common.home' | translate }}</a>
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
        </svg>
        <span>{{ 'compare.breadcrumb' | translate }}</span>
    </div>
    <h1 class="text-heading text-2xl font-semibold">{{ 'compare.title' | translate }}</h1>
</div>

<div class="bg-white px-3 sm:px-4 md:px-8 lg:px-16 pb-10 pt-3">
    <!-- Empty state -->
    <div *ngIf="!loading && products.length === 0"
         class="bg-surface rounded-lg p-10 flex flex-col items-center gap-4">
        <p class="text-body text-sm sm:text-base break-words text-center">{{ 'compare.empty' | translate }}</p>
        <a routerLink="/" class="text-primary font-semibold uppercase">{{ 'compare.browse' | translate }}</a>
    </div>

    <!-- Compare table -->
    <div *ngIf="products.length > 0" class="w-full">
        <div class="grid w-full grid-cols-[88px_minmax(0,1fr)_minmax(0,1fr)] sm:grid-cols-[120px_minmax(0,1fr)_minmax(0,1fr)] md:grid-cols-[180px_minmax(0,1fr)_minmax(0,1fr)]">
        <!-- PRODUCT row -->
        <div class="bg-[#444445] text-white text-center text-xs sm:text-sm md:text-base break-words flex items-center justify-center px-2 sm:px-4 md:pl-6 md:pr-4 py-3 sm:py-4">
            {{ 'compare.product' | translate }}
        </div>
        <ng-container *ngFor="let p of products">
            <div class="bg-white flex items-center justify-center px-2 sm:px-4 md:pl-6 md:pr-4 py-3 sm:py-4">
                <div *ngIf="p" class="flex flex-col items-center gap-2 w-full max-w-[240px] mx-auto">
                    <div class="h-[120px] sm:h-[200px] md:h-[240px] w-full max-w-[240px] bg-surface rounded flex items-center justify-center overflow-hidden">
                        <img *ngIf="p.featuredAsset?.preview"
                             [src]="p.featuredAsset!.preview + '?preset=medium'"
                             [alt]="p.name"
                             class="max-h-full max-w-full object-contain" />
                    </div>
                    <div class="flex items-center justify-center w-full">
                        <span class="text-body text-sm sm:text-base md:text-lg break-words text-center">{{ p.name }}</span>
                    </div>
                </div>
            </div>
        </ng-container>
        <ng-container *ngFor="let _ of placeholders">
            <div class="bg-white flex items-center justify-center px-2 sm:px-4 md:pl-6 md:pr-4 py-3 sm:py-4">
                <a routerLink="/"
                   class="flex flex-col gap-2 w-full max-w-[240px] h-[120px] sm:h-[200px] md:h-[240px] mx-auto bg-surface rounded border-2 border-dashed border-[#a1a4aa] items-center justify-center text-body hover:border-primary hover:text-primary transition-colors">
                    <svg class="w-7 h-7 sm:w-10 sm:h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 4.5v15m7.5-7.5h-15"/>
                    </svg>
                    <span class="text-xs sm:text-sm md:text-base font-medium text-center break-words px-1">{{ 'compare.addAnother' | translate }}</span>
                </a>
            </div>
        </ng-container>

        <!-- DESCRIPTION row -->
        <div class="bg-[#444445] text-white text-center text-xs sm:text-sm md:text-base break-words flex items-center justify-center px-2 sm:px-4 md:pl-6 md:pr-4 py-3 sm:py-4">
            {{ 'compare.description' | translate }}
        </div>
        <ng-container *ngFor="let p of products">
            <div class="bg-white flex items-center justify-center px-2 sm:px-4 md:pl-6 md:pr-4 py-3 sm:py-4 border-t border-b border-[#a1a4aa]">
                <div class="max-h-[140px] sm:max-h-[200px] w-full overflow-y-auto [scrollbar-width:thin]">
                    <p class="text-body text-sm sm:text-base text-center break-words" [innerHTML]="(p?.description || '—') | safeHtml"></p>
                </div>
            </div>
        </ng-container>
        <ng-container *ngFor="let _ of placeholders">
            <div class="bg-white flex items-center justify-center px-2 sm:px-4 md:pl-6 md:pr-4 py-3 sm:py-4 border-t border-b border-[#a1a4aa]">
                <div class="max-h-[140px] sm:max-h-[200px] w-full overflow-y-auto [scrollbar-width:thin] text-center">
                    <span class="text-disabled">—</span>
                </div>
            </div>
        </ng-container>

        <!-- BRAND row -->
        <div class="bg-[#444445] text-white text-center text-xs sm:text-sm md:text-base break-words flex items-center justify-center px-2 sm:px-4 md:pl-6 md:pr-4 py-3 sm:py-4">
            {{ 'compare.brand' | translate }}
        </div>
        <ng-container *ngFor="let p of products">
            <div class="bg-white flex items-center justify-center px-2 sm:px-4 md:pl-6 md:pr-4 py-3 sm:py-4 border-b border-[#a1a4aa]">
                <span class="text-body text-sm sm:text-base break-words text-center">{{ brand(p) }}</span>
            </div>
        </ng-container>
        <ng-container *ngFor="let _ of placeholders">
            <div class="bg-white flex items-center justify-center px-2 sm:px-4 md:pl-6 md:pr-4 py-3 sm:py-4 border-b border-[#a1a4aa]">
                <span class="text-disabled">—</span>
            </div>
        </ng-container>

        <!-- Dynamic spec rows -->
        <ng-container *ngFor="let row of specRows">
            <div class="bg-[#444445] text-white text-center text-xs sm:text-sm md:text-base break-words flex items-center justify-center px-2 sm:px-4 md:pl-6 md:pr-4 py-3 sm:py-4 uppercase">
                {{ row.name }}
            </div>
            <ng-container *ngFor="let v of row.values">
                <div class="bg-white flex items-center justify-center px-2 sm:px-4 md:pl-6 md:pr-4 py-3 sm:py-4 border-b border-[#a1a4aa]">
                    <div class="max-h-[120px] w-full overflow-y-auto [scrollbar-width:thin] text-center">
                        <span class="text-body text-sm sm:text-base break-words text-center">{{ v || '—' }}</span>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngFor="let _ of placeholders">
                <div class="bg-white flex items-center justify-center px-2 sm:px-4 md:pl-6 md:pr-4 py-3 sm:py-4 border-b border-[#a1a4aa]">
                    <div class="max-h-[120px] w-full overflow-y-auto [scrollbar-width:thin] text-center">
                        <span class="text-disabled">—</span>
                    </div>
                </div>
            </ng-container>
        </ng-container>

        <!-- CTA row -->
        <div class="bg-[#444445]"></div>
        <ng-container *ngFor="let p of products">
            <div class="bg-white flex items-center justify-center px-2 sm:px-4 md:pl-6 md:pr-4 py-3 sm:py-4 border-b border-[#a1a4aa]">
                <a *ngIf="p" [routerLink]="['/product', p.slug]"
                   class="flex-1 bg-primary text-white h-11 sm:h-[60px] rounded-md sm:rounded-lg flex items-center justify-center gap-1 sm:gap-3 px-2 sm:px-6 font-semibold uppercase text-xs sm:text-base text-center break-words leading-tight hover:bg-primary-600 transition-colors">
                    {{ 'compare.seeProduct' | translate }}
                </a>
            </div>
        </ng-container>
        <ng-container *ngFor="let _ of placeholders">
            <div class="bg-white border-b border-[#a1a4aa]"></div>
        </ng-container>
        </div>
    </div>
</div>
